<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <a-avatar
          shape="square"
          icon="user"
          size="large"
          :class="$style.avatar"
        />
      </a-badge>
    </div>
    <a-menu slot="overlay" v-if="$store.state.users.accounts.length == 1">
      <a-menu-item :disabled="true" style="color:#000">
        <div>
          <strong class="mr-1">{{ $store.state.users.userName }}</strong>
        </div>
        <div>
          <strong class="mr-1">Rol:</strong>
          {{ $store.state.users.userRoleName }}
        </div>
        <div>
          <strong class="mr-1">Cuenta:</strong>
          {{ $store.state.users.accounts[0].name }}
        </div>
        <!--<div><strong class="mr-1">Phone:</strong> -</div>-->
      </a-menu-item>
      <a-menu-divider />
      <!--<a-menu-item>
        <a href="javascript: void(0);">
          <i :class="$style.menuIcon" class="icmn-user"></i> Edit Profile
        </a>
      </a-menu-item>-->
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="icmn-exit"></i> Salir
        </a>
      </a-menu-item>
    </a-menu>

    <a-menu slot="overlay" v-else>
      <a-menu-item :disabled="true" style="color:#000">
        <div style="cursor:default">
          <strong class="mr-1">{{ $store.state.users.userName }}</strong>
        </div>
        <div>
          <strong class="mr-1">Rol:</strong>
          {{ $store.state.users.userRoleName }}
        </div>
        <!--<div><strong class="mr-1">Phone:</strong> -</div>-->
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item-group>
        <template slot="title">
          <a-icon type="home" />&nbsp;&nbsp;&nbsp;<span
            style="font-size:smaller"
            >CUENTAS</span
          >
        </template>
        <a-menu-item
          v-for="account in $store.state.users.accounts"
          :key="account.id"
          :disabled="account.selected"
        >
          <strong class="mr-1" v-if="account.selected" style="color:#333">{{
            account.name
          }}</strong>
          <div v-else :class="$style.menuItem">
            <a @click="handleSwitchAccount(account.id)">{{ account.name }}</a>
          </div>
        </a-menu-item>
      </a-menu-item-group>
      <a-menu-divider />
      <!--<a-menu-item>
        <a href="javascript: void(0);">
          <i :class="$style.menuIcon" class="icmn-user"></i> Edit Profile
        </a>
      </a-menu-item>-->
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="icmn-exit"></i> Salir
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";

export default {
  data: function() {
    return {
      count: 0
    };
  },
  methods: {
    addCount() {
      this.count++;
    },
    logout() {
      this.$auth.logout();
    },
    async handleSwitchAccount(accountId) {
      await this.$auth.switchAccount(accountId);
      const redirect = this.$route.query.redirect || "/";
      try {
        //intenta redireccionar a la home. Si ya esta en la home tira error.
        await this.$router.replace(redirect);
      } catch (err) {
        //si ya estaba en la home tira error entonces ir primero a otra pagina y despues si volver a la home
        await this.$router.replace("/customers");
        await this.$router.replace("/");
      }
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
